import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "../context/token";

interface IPrivateRouteProps {
  children: JSX.Element;
}

export const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  const location = useLocation();
  const token = localStorage.getItem(String(process.env.REACT_APP_LOCAL_KEY));

  if (!token) {
    return <Navigate to={"/"} state={{ from: location }} replace />;
  }

  return children;
};

export const PrivateRouteAdmin = ({ children }: IPrivateRouteProps) => {
  const location = useLocation();
  const { role } = getUser();

  if (role === "admin") {
    return children;
  }
  return <Navigate to={"/"} state={{ from: location }} replace />;
};
